import { render, staticRenderFns } from "./personnelinfo.vue?vue&type=template&id=d1b0ae2c&scoped=true&"
import script from "./personnelinfo.vue?vue&type=script&lang=js&"
export * from "./personnelinfo.vue?vue&type=script&lang=js&"
import style0 from "./personnelinfo.vue?vue&type=style&index=0&id=d1b0ae2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b0ae2c",
  null
  
)

export default component.exports